(function () {
  const initLookbook = () => {
    gsap.registerPlugin(ScrollTrigger);
    const slidesAll =
      document.currentScript.parentElement.querySelectorAll(".lookbook__slide");
    const thisWrapper =
      document.currentScript.parentElement.querySelector(".lookbook__wrapper");
    const thisPin =
      document.currentScript.parentElement.querySelector(".lookbook__slides");

    // NEO: The dedicated infinite-scroll asset owns movement in this mode.
    if (thisWrapper?.dataset.neoInfiniteScroll === "true") return;

    // NEO: Keep desktop scrolling aligned with the 990px responsive media swap.
    ScrollTrigger.matchMedia({
      "(min-width: 990px)": function () {
        const slides = gsap.utils.toArray(slidesAll);
        let maxWidth = 0;

        slides.forEach((slide) => {
          maxWidth += slide.offsetWidth;
        });

        gsap.to(slides, {
          x: () => `-${maxWidth - window.innerWidth / 1.03}`,
          ease: "linear",
          scrollTrigger: {
            trigger: thisWrapper,
            pin: thisPin,
            scrub: 1,
            start: () => "top top",
            end: () => `+=${maxWidth / 2}`,
          },
        });
      },
    });
  };

  // NEO 2026-10-15: Shared homepage/article slides store media ratios inline.
  // Swiper's cleanStyles removes these too; restore only ratios synchronously
  // so desktop measurement/cloning sees them, without retaining Swiper styles.
  // Revert by removing this helper and restoring the direct destroy(true, true) call.
  const neo_destroyMobileSwiper = (slider) => {
    const neo_swiper = slider.swiper;
    if (!neo_swiper) return;

    const neo_ratio_properties = [
      "--neo-lookbook-image-ratio",
      "--neo-lookbook-mobile-image-ratio",
      "--neo-lookbook-video-ratio",
      "--neo-lookbook-mobile-video-ratio",
    ];
    const neo_slide_ratios = Array.from(
      slider.querySelectorAll(".lookbook__slide"),
      (neo_slide) => ({
        neo_slide,
        neo_ratios: neo_ratio_properties
          .map((neo_property) => [
            neo_property,
            neo_slide.style.getPropertyValue(neo_property),
            neo_slide.style.getPropertyPriority(neo_property),
          ])
          .filter(([, neo_value]) => neo_value !== ""),
      })
    );

    neo_swiper.destroy(true, true);
    neo_slide_ratios.forEach(({ neo_slide, neo_ratios }) => {
      neo_ratios.forEach(([neo_property, neo_value, neo_priority]) => {
        neo_slide.style.setProperty(neo_property, neo_value, neo_priority);
      });
    });
  };

  const resizeLookbook = () => {
    const lookbookSections = document.querySelectorAll(".section-lookbook");
    const lookbookSwipers = document.querySelectorAll(".lookbook__swiper");

    const sectionResizeObserver = new ResizeObserver((entries) => {
      requestAnimationFrame(() => {
        const [entry] = entries;

        if (entry.contentRect.width < 990) {
          // for mobile 100vh viewport
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty("--vh", `${vh}px`);
          //

          lookbookSwipers.forEach((slider) => {
            if (!slider?.swiper) {
              const enableAutoHeight = slider.dataset.autoheight === "true";
              const enableInfiniteScroll =
                slider.dataset.neoInfiniteScroll === "true";
              const enableAutoSlide =
                slider.dataset.neoAutoSlide === "true" &&
                !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
              const autoSlideDelay =
                Number(slider.dataset.neoAutoSlideDelay) || 3000;
              const autoSlideSpeed =
                Number(slider.dataset.neoAutoSlideSpeed) || 30;

              slider
                .querySelector(".lookbook__slides")
                .classList.add("swiper-wrapper");
              slider
                .querySelectorAll(".lookbook__slide")
                .forEach((slide) => slide.classList.add("swiper-slide"));

              const lookbookSwiper = new Swiper(slider, {
                autoHeight: enableInfiniteScroll ? false : enableAutoHeight,
                slidesPerView: enableInfiniteScroll
                  ? "auto"
                  : enableAutoHeight
                    ? 1
                    : "auto",
                // NEO: Mobile remains finite because loop + freeMode + variable slide widths is unstable.
                loop: false,
                freeMode: {
                  enabled: enableInfiniteScroll || !enableAutoHeight,
                  momentum: true,
                  momentumRatio: 1.25,
                  momentumVelocityRatio: 0.8,
                  minimumVelocity: 0.02,
                },
                autoplay: false,
                initialSlide: 0,
              });

              // NEO: Mobile auto movement uses continuous px/s flow instead of slide-by-slide autoplay.
              if (enableAutoSlide) {
                let neoAutoFrame = 0;
                let neoAutoTimer = 0;
                let neoAutoLastTime = 0;
                let neoAutoVisible = false;
                let neoAutoCurrentSpeed = 0;

                const neoStopAutoFlow = () => {
                  window.clearTimeout(neoAutoTimer);
                  window.cancelAnimationFrame(neoAutoFrame);
                  neoAutoTimer = 0;
                  neoAutoFrame = 0;
                  neoAutoLastTime = 0;
                  neoAutoCurrentSpeed = 0;
                };

                const neoUpdateSwiperPosition = (translate) => {
                  lookbookSwiper.setTransition(0);
                  lookbookSwiper.setTranslate(translate);
                  lookbookSwiper.updateProgress(translate);
                  lookbookSwiper.updateActiveIndex();
                  lookbookSwiper.updateSlidesClasses();
                };

                const neoStartAutoFlow = () => {
                  if (
                    !neoAutoVisible ||
                    document.hidden ||
                    lookbookSwiper.destroyed ||
                    neoAutoFrame
                  ) {
                    return;
                  }

                  neoAutoLastTime = 0;
                  neoAutoFrame = window.requestAnimationFrame(neoRenderAutoFlow);
                };

                const neoResetAndRestart = () => {
                  if (!neoAutoVisible || document.hidden || lookbookSwiper.destroyed) return;

                  neoUpdateSwiperPosition(lookbookSwiper.minTranslate());
                  neoStartAutoFlow();
                };

                const neoScheduleAutoFlow = () => {
                  neoStopAutoFlow();
                  if (!neoAutoVisible || document.hidden || lookbookSwiper.destroyed) return;

                  neoAutoTimer = window.setTimeout(() => {
                    neoAutoTimer = 0;

                    if (
                      lookbookSwiper.getTranslate() <=
                      lookbookSwiper.maxTranslate() + 0.5
                    ) {
                      neoResetAndRestart();
                    } else {
                      neoStartAutoFlow();
                    }
                  }, autoSlideDelay);
                };

                function neoRenderAutoFlow(time) {
                  neoAutoFrame = 0;
                  if (!neoAutoVisible || document.hidden || lookbookSwiper.destroyed) return;

                  if (!neoAutoLastTime) {
                    neoAutoLastTime = time;
                    neoAutoFrame = window.requestAnimationFrame(neoRenderAutoFlow);
                    return;
                  }

                  const elapsed = Math.min(64, time - neoAutoLastTime) / 1000;
                  neoAutoLastTime = time;
                  const speedBlend = 1 - Math.exp(-3.5 * elapsed);
                  neoAutoCurrentSpeed +=
                    (autoSlideSpeed - neoAutoCurrentSpeed) * speedBlend;
                  const endTranslate = lookbookSwiper.maxTranslate();
                  const nextTranslate = Math.max(
                    endTranslate,
                    lookbookSwiper.getTranslate() - neoAutoCurrentSpeed * elapsed
                  );

                  neoUpdateSwiperPosition(nextTranslate);

                  if (nextTranslate <= endTranslate + 0.5) {
                    neoAutoCurrentSpeed = 0;
                    neoAutoTimer = window.setTimeout(() => {
                      neoAutoTimer = 0;
                      neoResetAndRestart();
                    }, autoSlideDelay);
                    return;
                  }

                  neoAutoFrame = window.requestAnimationFrame(neoRenderAutoFlow);
                }

                const neoOnTouchStart = () => neoStopAutoFlow();
                const neoOnTouchEnd = () => neoScheduleAutoFlow();
                const neoOnTransitionStart = () => neoStopAutoFlow();
                const neoOnTransitionEnd = () => neoScheduleAutoFlow();
                const neoOnVisibilityChange = () => {
                  if (document.hidden) {
                    neoStopAutoFlow();
                  } else {
                    neoScheduleAutoFlow();
                  }
                };
                const neoVisibilityObserver = new IntersectionObserver(
                  ([entry]) => {
                    neoAutoVisible = entry.isIntersecting;
                    if (neoAutoVisible) {
                      neoScheduleAutoFlow();
                    } else {
                      neoStopAutoFlow();
                    }
                  },
                  { threshold: 0.01 }
                );

                lookbookSwiper.on("touchStart", neoOnTouchStart);
                lookbookSwiper.on("touchEnd", neoOnTouchEnd);
                lookbookSwiper.on("transitionStart", neoOnTransitionStart);
                lookbookSwiper.on("transitionEnd", neoOnTransitionEnd);
                document.addEventListener("visibilitychange", neoOnVisibilityChange);
                neoVisibilityObserver.observe(slider);

                slider.neoLookbookAutoFlowCleanup = () => {
                  neoStopAutoFlow();
                  neoVisibilityObserver.disconnect();
                  document.removeEventListener("visibilitychange", neoOnVisibilityChange);
                  lookbookSwiper.off("touchStart", neoOnTouchStart);
                  lookbookSwiper.off("touchEnd", neoOnTouchEnd);
                  lookbookSwiper.off("transitionStart", neoOnTransitionStart);
                  lookbookSwiper.off("transitionEnd", neoOnTransitionEnd);
                  delete slider.neoLookbookAutoFlowCleanup;
                };
              }
            }
          });
        } else {
          // for mobile 100vh viewport
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty("--vh", `${vh}px`);
          //

          lookbookSwipers.forEach((slider) => {
            slider.neoLookbookAutoFlowCleanup?.();
            neo_destroyMobileSwiper(slider);
            slider
              .querySelector(".lookbook__slides")
              .classList.remove("swiper-wrapper");
            slider
              .querySelectorAll(".lookbook__slide")
              .forEach((slide) => slide.classList.remove("swiper-slide"));
          });
        }
      });
    });

    lookbookSections.forEach((section) => {
      sectionResizeObserver.observe(section);
    });
  };

  const controlsVideo = () => {
    const buttonsPlay = document.querySelectorAll(".js-slide-play-video");
    const buttonsSound = document.querySelectorAll(".js-slide-sound-video");

    buttonsPlay.forEach((button) => {
      button.onclick = () => {
        if (
          button.previousElementSibling.classList.contains(
            "lookbook__slide_show__video"
          )
        ) {
          const video = button.previousElementSibling.querySelector("video");
          if (video) {
            if (video.paused) {
              setTimeout(() => {
                video.play();
              }, 10);
            } else {
              setTimeout(() => {
                video.pause();
              }, 10);
            }
            button.classList.toggle("active");
          }

          const videoUrl =
            button.previousElementSibling.querySelector("iframe");
          if (videoUrl) {
            if (videoUrl.classList.contains("video-pause")) {
              if (videoUrl.classList.contains("js-vimeo")) {
                videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
                if (videoUrl.classList.contains("video-muted")) {
                  videoUrl.contentWindow.postMessage(
                    '{"method":"setVolume", "value":0}',
                    "*"
                  );
                } else {
                  videoUrl.contentWindow.postMessage(
                    '{"method":"setVolume", "value":1}',
                    "*"
                  );
                }
                videoUrl.classList.add("video-play");
                videoUrl.classList.remove("video-pause");
              }
            } else {
              if (videoUrl.classList.contains("js-slide-vimeo")) {
                videoUrl.contentWindow.postMessage('{"method":"pause"}', "*");
                videoUrl.classList.add("video-pause");
                videoUrl.classList.remove("video-play");
              }
            }
            button.classList.toggle("active");
          }
        }
      };
    });

    buttonsSound.forEach((button) => {
      button.onclick = () => {
        if (
          button.previousElementSibling.classList.contains(
            "lookbook__slide_show__video"
          ) ||
          button.previousElementSibling.previousElementSibling.classList.contains(
            "lookbook__slide_show__video"
          )
        ) {
          const video =
            button.previousElementSibling.querySelector("video") ||
            button.previousElementSibling.previousElementSibling.querySelector(
              "video"
            );
          if (video) {
            if (video.muted) {
              setTimeout(() => {
                video.muted = false;
              }, 10);
            } else {
              setTimeout(() => {
                video.muted = true;
              }, 10);
            }
            button.classList.toggle("active");
          }

          const videoUrl =
            button.previousElementSibling.querySelector("iframe") ||
            button.previousElementSibling.previousElementSibling.querySelector(
              "iframe"
            );
          if (videoUrl) {
            if (videoUrl.classList.contains("video-muted")) {
              if (videoUrl.classList.contains("js-vimeo")) {
                videoUrl.contentWindow.postMessage(
                  '{"method":"setVolume", "value":1}',
                  "*"
                );
                videoUrl.classList.remove("video-muted");
              }
            } else {
              if (videoUrl.classList.contains("js-vimeo")) {
                videoUrl.contentWindow.postMessage(
                  '{"method":"setVolume", "value":0}',
                  "*"
                );
                videoUrl.classList.add("video-muted");
              }
            }
            button.classList.toggle("active");
          }
        }
      };
    });
  };

  initLookbook();
  resizeLookbook();

  setTimeout(() => {
    controlsVideo();
  }, 100);

  document.addEventListener("shopify:section:load", function (event) {
    const section = event.detail?.section || event.target;
    initLookbook();
    resizeLookbook();
    controlsVideo();
  });

  document.addEventListener("shopify:section:reorder", function () {
    initLookbook();
    resizeLookbook();
    controlsVideo();
  });
})();
